/**
 * Copyright 2021 (c) Moritz Walker, ISW University of Stuttgart (for umati and VDW e.V.)
 */
import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { labels } from '@umati/dashboard-common';
import { getInfoWindow } from './CustomInfoWindow';
import ENVs from 'utilities/ENVs';

export const getInner = (name, onMouseLeave, img, children, path, altImg = <></>) => {
  return <div className="pin-info text-center" onMouseLeave={onMouseLeave}>
    <div className="pin-info-head mb-2">
      <span className="h5">{name}</span>
    </div>
    <div className="pin-info-body">
      <div className="pin-info-logo mb-2">
        <img src={img} onError={(error) => { error.target.onerror = null; error.target.src = `${ENVs.WatermarkedBucketUrl()}/watermarked/test-image.jpg`; }} alt="" />
        {altImg}
      </div>
      {children}
      <Link to={path}><button className="btn btn-sm btn-outline-primary">{labels.showMore}</button></Link>
    </div>
  </div>;
};

export default class SwInfoWindow extends Component {
  render() {
    const inner = getInner(this.props.name, this.props.onMouseLeave, this.props.iconUrl, this.props.children, this.props.Path);
    return (getInfoWindow(this.props, inner));
  }
}
